import { render, staticRenderFns } from "./MyTreeMenu.vue?vue&type=template&id=cb53212e&scoped=true"
import script from "./MyTreeMenu.vue?vue&type=script&lang=js"
export * from "./MyTreeMenu.vue?vue&type=script&lang=js"
import style0 from "./MyTreeMenu.vue?vue&type=style&index=0&id=cb53212e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb53212e",
  null
  
)

export default component.exports